
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { SortConfig } from "../hooks/useSortableData";

interface SortableHeaderCellProps<T> {
  column: {
    key: keyof T | string;
    header: string;
    sortable?: boolean;
    width?: string;
    className?: string;
    /** KB-4000: opt-in override for the sort Button's classes (e.g. to allow
     * a multi-word header to wrap instead of forcing whitespace-nowrap). */
    headerClassName?: string;
  };
  sortConfig: SortConfig<T>;
  onSort: (key: string) => void;
}

function SortableHeaderCell<T>({ column, sortConfig, onSort }: SortableHeaderCellProps<T>) {
  if (!column.sortable) {
    return <span dangerouslySetInnerHTML={{ __html: column.header }} />;
  }

  return (
    <Button
      variant="ghost"
      className={cn(
        "h-8 px-2 text-left font-medium text-muted-foreground hover:text-foreground",
        column.headerClassName
      )}
      onClick={() => onSort(String(column.key))}
    >
      <span dangerouslySetInnerHTML={{ __html: column.header }} />
      {sortConfig.key === String(column.key) ? (
        sortConfig.direction === "asc" ? (
          <ArrowUp className="ml-2 h-4 w-4" />
        ) : (
          <ArrowDown className="ml-2 h-4 w-4" />
        )
      ) : (
        <ArrowUpDown className="ml-2 h-4 w-4" />
      )}
    </Button>
  );
}

export default SortableHeaderCell;
